import { render, staticRenderFns } from "./BulkInputDialog.vue?vue&type=template&id=71480017&"
import script from "./BulkInputDialog.vue?vue&type=script&lang=ts&"
export * from "./BulkInputDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports